import { Component, Input } from '@angular/core';

import { User } from '../../../entities/index';

@Component({
  selector: 'app-tracker-owner',
  templateUrl: './tracker-owner.html'
})
export class TrackerOwnerComponent {
  @Input()
  user: User;
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/tracker-owner/tracker-owner.component.ts